document.addEventListener('DOMContentLoaded', function() {
  
  function checkVariantSelection() {
    const variantSelects = document.querySelectorAll(
      'select[name="id"], .product-form__input select, select.product-form__select, .quick-view select, .product-info-sections--quick-view select'
    );
    const addToCartButtons = document.querySelectorAll(
      'button[name="add"], .product-form__submit, button[type="submit"], .quick-view button[type="submit"], .product-info-sections--quick-view button[type="submit"]'
    );
    
    let hasPlaceholder = false;
    
    variantSelects.forEach(function(select) {
      if (select.offsetParent !== null) { // Nur sichtbare Selects prüfen
        const selectedOption = select.options[select.selectedIndex];
        const selectedText = selectedOption?.text || '';
        const selectedValue = selectedOption?.value || '';
        
        // Prüfe ob ein Platzhalter ausgewählt ist ODER kein Wert
        if (selectedText.includes('Hier bitte') || selectedText.includes('– Hier') || selectedText.includes('Größe auswählen') || selectedText.includes('Paneel auswählen') || selectedText.includes('Regal auswählen') || selectedValue === '' || selectedValue === 'null') {
          hasPlaceholder = true;
        }
      }
    });

    // Button deaktivieren wenn mindestens EIN Platzhalter ausgewählt ist
    addToCartButtons.forEach(function(button) {
      // Montageuntergrund-Auswahl wird separat geprüft; niemals hier entsperren.
      if (button.matches('[data-wt-mount-gate]') || button.closest('form[data-wt-mount-required="true"]')) return;
      if (hasPlaceholder) {
        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
        button.style.pointerEvents = 'none';
      } else {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        button.style.pointerEvents = 'auto';
      }
    });
  }
  
  // Event Listener für alle Selects
  document.addEventListener('change', function(e) {
    if (e.target.tagName === 'SELECT') {
      checkVariantSelection();
    }
  });
  
  // Initial check mit Verzögerung UND bei Seitenänderungen
  setTimeout(checkVariantSelection, 500);
  setTimeout(checkVariantSelection, 1000);
  
  // Zusätzlicher Check bei Klick auf den Button
  document.addEventListener('click', function(e) {
    if (e.target.matches('button[name="add"], .product-form__submit')) {
      checkVariantSelection();
    }
  }, true);

  // Observer für dynamisch geladene Quick-View Elemente
  const observer = new MutationObserver(function() {
    setTimeout(checkVariantSelection, 300);
  });
  
  observer.observe(document.body, { childList: true, subtree: true });

});
